import * as React from 'react';
import "./ticker.css";

const items = [
    "Save Up To $45,000 / Year",
    "Free Forever Plan",
    "14 Days Free Trial",
    "Transparent Billing",
    "No Price Surprises",
    "Keep More Profit",
    "Made For Store Owners",
    "Join Thousands Of Stores",
    "Your Data Is Protected",
    "Setup In Few Minutes",
    "Works On Your Phone / Tablet / PC / Mac",
    "No Tech Skills Needed",
    "Move Your Data Free",
    "Start Selling Today",
    "Point Of Sale",
    "Track All Your Stock",
    "Know What Sells Best",
    "Sell Online Too(Included)",
    "Your Own Website",
    "Open 24 / 7 Online",
    "Self Checkout Ready",
    "Reward Loyal Customers",
    "Run Sales, Promos & Deals",
    "Gift Cards Built - In",
    "Handle Returns / Exchange Easy",
    "Manage Your Team",
    "Store Map Included",
    "Track Every Purchase Orders",
    "Sales Tax & Special Tax Handled",
    "Accept All Card Types",
    "Tap-To-Pay Ready",
    "Apple Pay & Google Pay",
    "Pick Your Payment Processors",
    "Switch Payment Processors Anytime",
    "Get The Lowest Rate",
    "Accept Crypto Too",
    "Get Paid Fast",
    "Add More Stores Easy",
    "Grow Without Limits",
    "Sell More Every Day",








];

export function Ticker() {
    return (
        <div className="ticker-wrap">
            <div className="ticker-track">
                {[...items, ...items].map((item, i) => (
                    <span className="ticker-item" key={i}>
                        {item}
                        <span className="dot">•</span>
                    </span>
                ))}
            </div>
        </div>
    );
}